// this file is automatically generated by the generate_variables.sh script
const variables = {
  honeybadgerApiKey: 'bcefe329',
  revision: 'v4.40.1',
};

module.exports = variables;
